import styled from '@emotion/styled';
import React from 'react';

import type { LensDivProps, ResponsiveType } from '../../types';
import { getSize } from '../../utilities';

const SpacerWrapper = styled.div<SpacerProps>`
  display: ${props => (props.isInline ? 'inline-block' : 'block')};
  vertical-align: middle;
  ${props => getSize('padding', props.all)};
  ${props => getSize('padding-top', props.top)};
  ${props => getSize('padding-right', props.right)};
  ${props => getSize('padding-bottom', props.bottom)};
  ${props => getSize('padding-left', props.left)};
`;

const Spacer = ({
  children,
  all,
  y,
  x,
  top,
  right,
  bottom,
  left,
  isInline,
  ...props
}: SpacerProps &
  React.ComponentProps<typeof SpacerWrapper> &
  Omit<
    LensDivProps,
    keyof SpacerProps & React.ComponentProps<typeof SpacerWrapper>
  >) => (
  <SpacerWrapper
    all={all}
    top={y || top}
    bottom={y || bottom}
    right={x || right}
    left={x || left}
    isInline={isInline}
    {...props}
  >
    {children}
  </SpacerWrapper>
);

type SpacerProps = {
  all?: ResponsiveType<string | number>;
  y?: ResponsiveType<string | number>;
  x?: ResponsiveType<string | number>;
  left?: ResponsiveType<string | number>;
  right?: ResponsiveType<string | number>;
  top?: ResponsiveType<string | number>;
  bottom?: ResponsiveType<string | number>;
  isInline?: boolean;
  children?: React.ReactNode;
};

export default Spacer;
